import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Target, Activity, Settings } from 'lucide-react';

const COLORS = {
  white: '#ffffff',
  navy: '#1a1a3e',
  orange: '#FF8C42',
  gray: {
    200: '#e8ecee',
    400: '#9ba4ab',
    600: '#4c5b62'
  }
};

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: 'home', icon: Home, label: 'Home', path: '/dashboard' },
    { id: 'goals', icon: Target, label: 'Goals', path: '/goals' },
    { id: 'activity', icon: Activity, label: 'Activity', path: '/activity' },
    { id: 'settings', icon: Settings, label: 'Settings', path: '/settings' }
  ];

  const isActive = (path) => {
    // Check if current path matches or starts with the nav item path
    if (path === '/dashboard' && location.pathname === '/dashboard') return true;
    if (path === '/goals' && (location.pathname === '/goals' || location.pathname.startsWith('/goal/'))) return true;
    if (path === '/activity' && location.pathname === '/activity') return true;
    if (path === '/settings' && location.pathname === '/settings') return true;
    return false;
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: COLORS.white,
      borderTop: `1px solid ${COLORS.gray[200]}`,
      padding: '0.75rem 1rem 1.5rem',
      display: 'flex',
      justifyContent: 'space-around',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.05)',
      zIndex: 1000,
      maxWidth: '100vw'
    }}>
      {navItems.map((item) => {
        const IconComponent = item.icon;
        const active = isActive(item.path);
        
        return (
          <button
            key={item.id}
            onClick={() => navigate(item.path)}
            style={{
              background: 'none',
              border: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.25rem',
              cursor: 'pointer',
              padding: '0.5rem 1rem',
              transition: 'all 0.2s',
              color: active ? COLORS.orange : COLORS.gray[600]
            }}
          >
            <IconComponent 
              size={24} 
              style={{ 
                strokeWidth: active ? 2.5 : 2
              }} 
            />
            <span style={{
              fontSize: '0.75rem',
              fontWeight: active ? '600' : '400',
              color: active ? COLORS.orange : COLORS.gray[600]
            }}>
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default BottomNav;